import { combineReducers } from 'redux';
import entitiesReducer from './entities';
import videoMeetingSlice from './videoMeetingSlice';
import messengerSlice from './messengerSlice';

export default combineReducers({
  entities: entitiesReducer,
  videoMeeting:videoMeetingSlice,
  messenger:messengerSlice
});